import React from 'react';
import { Home, Solution } from './components';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import "./App.css";
import Pricing from './pages/Pricing';
import PCI from './pages/PCI';
import Docs from './pages/Docs';
import ComplaintForm from './pages/complaints';
import DocsGuide from './pages/docs/DocsGuide';
import LifeCycle from './pages/docs/LifeCycle';
import Payment from './pages/docs/Payment';
// import MerchantDashboard from './pages/docs/MerchantDashboard';
import PaymentLink from './pages/docs/PaymentLink';
import GetStarted from './pages/docs/GetStarted';
import TestEnv from './pages/docs/TestEnv';
import ApiEnc from './pages/docs/ApiEnc';
import TestCard from './pages/docs/TestCard';
import DirectWebIntegration from './pages/docs/DirectWebIntegration2';
import Contact from './pages/contact';
import ProductFraud from './pages/ProductFraud';
import ScrollOnRouteChange from "./utils/ScrollOnRouteChange";
import Privacy from './components/privacy';
import Cookies from './components/Cookies';
import Terms from './components/Terms';
import SupportButton from './components/support/supportButton';
import WebsiteChatAssistant from './components/chatbot/chatbot';
import NotFound from './pages/NotFound';
import Settlement from './pages/docs/settlement';
import lazyPage from './utils/lazyPage';
import LegacyRedirect from './components/documentation/sdks/LegacyRedirect';

// SDKs & Plugins: downloaded only when visited, so other pages don't pay for them.
const SdksHub = lazyPage(() => import('./components/documentation/sdks/SdksHub'));
const SdkPage = lazyPage(() => import('./components/documentation/sdks/SdkPage'));


function App() {
    return (
        <Router>
            <ScrollOnRouteChange>
                <div className='mb-5'>
                  <Switch>
                    {/* Strip a trailing slash (/pricing/ -> /pricing) so it doesn't land on the 404 page */}
                    <Route
                        exact
                        strict
                        path="/:url+/"
                        render={({ location }) => (
                            <Redirect to={{ ...location, pathname: location.pathname.replace(/\/+$/, '') }} />
                        )}
                    />

                    <Route path="/" exact strict component={Home} />
                    <Route path="/features" exact strict component={Solution} />
                    <Route path="/contact" exact strict component={Contact} />
                    <Route path="/pricing" exact strict component={Pricing} />
                    <Route path="/compliance" exact strict component={PCI} />
                    
                    <Route path="/get-started" exact strict component={Docs} />
                    <Route path="/complaints" exact strict component={ComplaintForm} />
                    <Route path="/registration-guide" exact strict component={DocsGuide} />
                    <Route path="/payment-life-cycle" exact strict component={LifeCycle} />
                    <Route path="/payment" exact strict component={Payment} />
                    {/* <Route path="/merchant-dashboard" exact strict component={MerchantDashboard} /> */}
                    <Route path="/payment-link" exact strict component={PaymentLink} />
                     <Route path="/settlement" exact strict component={Settlement} />
                    <Route path="/dev-get-started" exact strict component={GetStarted} />
                    <Route path="/test-environment" exact strict component={TestEnv} />
                    
                    <Route path="/api-encryption" exact strict component={ApiEnc} />
                    <Route path="/sdks" exact strict component={SdksHub} />
                    <Route path="/sdks/:slug" exact strict component={SdkPage} />
                    {/* Old addresses: /web-integration#php → /sdks/php and so on */}
                    <Route path="/web-integration" exact strict render={() => <LegacyRedirect kind="web" />} />
                    <Route path="/mobile-integration" exact strict render={() => <LegacyRedirect kind="mobile" />} />
                    <Route path="/test-card-information" exact strict component={TestCard} />
                    <Route path="/standard-api-integration" exact strict component={DirectWebIntegration} />

                    <Route path="/plugin-sdk" exact strict render={() => <LegacyRedirect kind="web" />} />
                    <Route path="/product-fraud" exact strict component={ProductFraud} />
                    <Route path="/privacy" exact strict component={Privacy} />
                    <Route path="/cookies" exact strict component={Cookies} />
                    <Route path="/terms" exact strict component={Terms} />

                    {/* Must stay last: anything not matched above shows the 404 page */}
                    <Route component={NotFound} />
                  </Switch>
                </div>
                <SupportButton />
                <WebsiteChatAssistant/>
            </ScrollOnRouteChange>
        </Router>
    )
}

export default App

